import { topicGroups } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function TopicCloud() {
  return (
    <section id="topics" className="w-full bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28">
        <SectionHeading
          kicker="TOPICS"
          title="话题聚合分组"
          desc="把分散的看点按主题归好类，想追哪个方向，直接点进对应话题，不用在信息流里反复翻找。"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {topicGroups.map((group) => (
            <div
              key={group.name}
              className="p-6 md:p-7 rounded-lg bg-background-50 border border-background-200/80 flex flex-col"
            >
              <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-hashtag" />
                </span>
              </span>
              <h4 className="mt-5 font-heading font-black text-foreground-950 text-lg md:text-xl">
                {group.name}
              </h4>
              <p className="mt-2 text-xs md:text-sm text-foreground-500">{group.desc}</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {group.tags.map((tag) => (
                  <a
                    key={tag}
                    href="#board"
                    className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap"
                  >
                    {tag}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 rounded-lg bg-foreground-950 p-6 md:p-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="max-w-2xl">
            <h4 className="font-heading font-black text-background-50 text-xl md:text-3xl leading-tight">
              每天花三分钟，掌握当下的热门与爆款
            </h4>
            <p className="mt-3 text-sm md:text-base text-background-200/75 leading-relaxed">
              看料91热门与爆款持续更新，高能焦点、热议话题一次看全，省下到处翻找的时间。
            </p>
          </div>
          <a
            href="#top"
            className="shrink-0 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-950 text-sm md:text-base font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap"
          >
            回到顶部看热榜
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-up-line" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}